import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS
} from '../../../../AppDesigner/Elements';

const fields = {
  group: ELEMENT_GROUPS.TEXT,
  name: 'CSVImport',
  label: 'CSV Importer',
  icon: 'DocumentTextIcon',
  description: 'Imports CSV content for a particular content type',
  properties: [
    {
      label: 'Content Type Name',
      name: 'contentTypeName',
      editor: 'textbox',
      readonly: false,
      description: 'The content type of the data to be imported',
      options: [],
      function: {
        name: 'getContentTypes',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Firestore Path',
      name: 'path',
      editor: 'textbox',
      readonly: false,
      description:
        'The path to where the data should be imported to. You can use squirrelly placeholders such as /mycollection/{{it.object.id}}/subcollection etc',
      options: [],
      function: {
        name: 'getContentTypes',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Additional Data Parameters',
      name: 'params',
      editor: 'textarea',
      readonly: false,
      description:
        'A json object containing parameters to pass to the import function. Typically this will include keys and values that denote additional keys to include in the imported data. i.e. a parent document id. You can also use placeholders i.e { organisationid: "{{it.user.organisationId}}" }',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Page Data Link',
      name: 'dataLinkId',
      description:
        'Choose a Data Link assigned to this page that the import will be associated with.',
      editor: 'dropdown',
      function: {
        name: 'getDataLinks',
        params: ['element.pageDataLinks']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'On Cancel Toggle Key',
      name: 'toggle',
      editor: 'textbox',
      readonly: false,
      description:
        'Provide a local store key name to toggle when the cancel button is clicked that should hide the dialog.',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Import Button Classes',
      name: 'importButtonClasses',
      editor: 'textbox',
      readonly: false,
      description:
        'Space separated list of tailwind class names to override the default import button appearance.',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.STYLE
    },
    {
      label: 'Placeholder Text',
      name: 'placeholder',
      editor: 'textbox',
      readonly: false,
      description:
        'The text to display in the import textarea field - usually an example of the csv required.',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    }
  ]
};

export default fields;
